import React from "react"
import { CaseStudyTemplate } from "./CaseStudyTemplate"

export default function EbenezerCaseStudy() {
  return (
    <CaseStudyTemplate
      backToAnchorId="selected-work-ebenezer"
      eyebrow="Selected work"
      tag="Construction"
      title="Ebenezer Drafting & Construction LTD — Brand Presence Refresh"
      summary="A professional brand presentation designed to build trust fast—clean visuals and messaging that communicates capability in drafting, architecture, and construction delivery."
      image="/Ebenzer.png"
      imageAlt="Ebenezer Drafting and Construction branding visual"
      sections={[
        {
          title: "The goal",
          body: "Position the company as credible and detail-driven—so residential and commercial clients feel confident from the first impression.",
        },
        {
          title: "What we focused on",
          body: "Clarity and structure: messaging that highlights drafting accuracy, build quality, and reliable delivery. Visuals were kept clean and professional to match the industry.",
        },
        {
          title: "Outcome",
          body: "A stronger, more consistent presence that supports sales conversations and makes it easier to present services across proposals, social, and web touchpoints.",
        },
      ]}
      tech={["Brand Messaging", "Logo Refinement", "Adobe Illustrator", "Adobe Photoshop"]}
      results={[
        "Trust-building presentation",
        "Clear service positioning",
        "Consistent brand use",
        "Client-ready visuals",
      ]}
    />
  )
}

